export default {
    namespaced: true,
    state: {
        gameSpot: '',
    },
    mutations: {
        setPhone(state, value) {
            state.phone = value
        },
        setGameSpot(state, value) {
            state.gameSpot = value
        },
    },
  
    getters: {
        getGameSpot: state => state.gameSpot,
    }
}
